import { ShoppingCart, ReceiptText, Award, User as UserIcon, BarChart3 } from 'lucide-react';

export type ProfileTab = 'overview' | 'stats' | 'rewards' | 'orders' | 'history';

const TABS: { id: ProfileTab; label: string; icon: typeof UserIcon }[] = [
    { id: 'overview', label: 'Overview',   icon: UserIcon     },
    { id: 'stats',    label: 'Statistics', icon: BarChart3    },
    { id: 'rewards',  label: 'Rewards',    icon: Award        },
    { id: 'orders',   label: 'Orders',     icon: ShoppingCart },
    { id: 'history',  label: 'History',    icon: ReceiptText  },
];

interface TabNavigationProps {
    activeTab: ProfileTab;
    setActiveTab: (tab: ProfileTab) => void;
}

export function TabNavigation({ activeTab, setActiveTab }: TabNavigationProps) {
    return (
        <div className="flex gap-1.5">
            {TABS.map(({ id, label, icon: Icon }) => (
                <button
                    key={id}
                    type="button"
                    onClick={() => setActiveTab(id)}
                    className={`flex items-center gap-2 px-3.5 py-2 rounded-xl text-xs sm:text-sm font-semibold transition-all duration-200 ${
                        activeTab === id
                            ? 'bg-gradient-to-br from-emerald-600 via-emerald-800 to-gray-900 text-white'
                            : 'text-gray-400 hover:text-white hover:bg-white/5'
                    }`}
                >
                    <Icon size={15} />
                    {label}
                </button>
            ))}
        </div>
    );
}
